import api from "api";

export const fetchImages = async () => await api.get("/images");
export const searchImageByType = async (data) => await api.post("/images/search-by-type", data);
export const fetchCapacity = async () => await api.get("/capacity");
